/**
 * WS2 strangle: the native cooperative section components (CooperativeBigPicture /
 * CooperativePartners) were hybrids — native UI bridged to the AngularJS ng-redux
 * store via `$injector.get('$ngRedux')`, reading `state.views.cooperative.{bigPicture,
 * partners}` + the cooperative-private `state.apiData.propertiesStatistics` and
 * dispatching the account-v2 cooperative thunks. Moved that state to a native NgRx
 * feature so the components leave the ng-redux store. REUSES the account-v2 reducers
 * VERBATIM (plain redux reducers are valid NgRx ActionReducers).
 *
 * State-only: the cooperative ROUTE is still an AngularJS state (the account-v2
 * `ftCooperative` host + StateConfig), a WS4 router concern — so the account-v2
 * cooperative module stays; its now-unread ng-redux `views.cooperative` +
 * `apiData.propertiesStatistics` slices are dead cleanup for that WS4 work.
 *
 * Feature key `cooperativeLegacyViews` (avoids collision with any future native
 * `cooperative` feature).
 */
import { ActionReducer, ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import cooperativeReducer from '../../../../account-v2/src/app/features/cooperative/reducers';
import propertiesStatistics from '../../../../account-v2/src/app/reducers/api-data/propertiesStatistics';

export const COOPERATIVE_LEGACY_FEATURE = 'cooperativeLegacyViews';

export interface CooperativeLegacyState {
  cooperative: any;
  propertiesStatistics: any;
}

export const cooperativeLegacyReducers: ActionReducerMap<CooperativeLegacyState> = {
  cooperative: cooperativeReducer as ActionReducer<any>,
  propertiesStatistics: propertiesStatistics as ActionReducer<any>,
};

export const selectCooperativeLegacyFeature =
  createFeatureSelector<CooperativeLegacyState>(COOPERATIVE_LEGACY_FEATURE);
